import React from 'react';
import 'katex/dist/katex.min.css';

const MathRenderer = ({ content }) => {
  if (!content) return null;

  // Function to render inline and block LaTeX formulas
  const renderMath = (text) => {
    // Handle display math: \[...\] or $$...$$
    let processed = text.replace(/\\\[(.*?)\\\]|\$\$(.*?)\$\$/gs, (match, p1, p2) => {
      const formula = p1 || p2;
      try {
        const katex = require('katex');
        return `<div class="math-block">${katex.renderToString(formula, {
          displayMode: true,
          throwOnError: false,
          trust: true
        })}</div>`;
      } catch (e) {
        return match;
      }
    });

    // Handle inline math: \(...\) or $...$
    processed = processed.replace(/\\\((.*?)\\\)|\$([^\$]+?)\$/g, (match, p1, p2) => {
      const formula = p1 || p2;
      try {
        const katex = require('katex');
        return `<span class="math-inline">${katex.renderToString(formula, {
          displayMode: false,
          throwOnError: false,
          trust: true
        })}</span>`;
      } catch (e) {
        return match;
      }
    });

    return processed;
  };

  const renderedContent = renderMath(content);

  return (
    <div 
      className="math-content"
      dangerouslySetInnerHTML={{ __html: renderedContent }}
    />
  );
};

export default MathRenderer;
